module.exports = __webpack_public_path__ + "img/violet_011.556dbe14.png";